var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFmpi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1315c;}.cls-2{fill:#fce3f1;}.cls-3,.cls-6{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:8px;}.cls-3{stroke:#4d4d4d;}.cls-4{fill:#f384a1;}.cls-5{fill:#fff;}.cls-6{stroke:#fff;}.cls-7{fill:#febe10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fmpi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.88,469.05c-13.82-169.61-7.51-222.47,4.54-225.37,3.82-.92,10.36,4.93,23.29,16.68,20.95,19,50.91,50.23,61.65,64.46C193.8,374.35,155.44,419.52,129.88,469.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.74,295.27c12.35-5.08,49.62,42.81,51.08,41.71,3,.13-52,55.56-52.23,55.83C150.41,388.87,139,298.88,147.74,295.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.16,472.61C481,303,474.67,250.14,462.62,247.23c-3.83-.92-10.37,4.94-23.3,16.69-20.94,19-50.9,50.23-61.64,64.45C403.24,377.91,441.6,423.08,467.16,472.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M449.29,298.83c-12.35-5.09-49.61,42.8-51.07,41.71-3.05.13,52,55.56,52.23,55.83C446.62,392.43,458.05,302.44,449.29,298.83Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 298.82,
    cy: 449.93,
    rx: 170.34,
    ry: 148.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "muzzle",
    className: "cls-2",
    cx: 298.84,
    cy: 507.59,
    rx: 81.15,
    ry: 67.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "mouth"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.41,502.67c-.05,3.19-.64,16.51-11.14,27.23a39.32,39.32,0,0,1-18.55,10.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300,502.67c.06,3.19.65,16.51,11.15,27.23a39.26,39.26,0,0,0,18.54,10.53"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 300,
    y1: 478.22,
    x2: 300,
    y2: 514.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305,496.65a8.49,8.49,0,0,1-9,.1A72,72,0,0,1,281.82,485a61.65,61.65,0,0,1-10.45-15.23c-1.54-3.19.42-6.83,4.34-7.94a91.67,91.67,0,0,1,49.29-.07c4,1.12,6.06,4.82,4.41,8a67.87,67.87,0,0,1-12.48,17A76.8,76.8,0,0,1,305,496.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.29,
    cy: 402.86,
    r: 24.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 253.61,
    cy: 392.81,
    r: 8.02
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.56,
    cy: 402.86,
    r: 24.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 357.89,
    cy: 392.81,
    r: 8.02
  })), /*#__PURE__*/React.createElement("g", {
    id: "whiskers"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M349.56,487.6a175.53,175.53,0,0,1,151.22,22.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.42,509.79A158.47,158.47,0,0,1,464,550.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.78,487.6a175.53,175.53,0,0,0-151.22,22.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M244.93,509.79a158.47,158.47,0,0,0-106.57,40.49"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "382.54 280.79 477.67 158.75 420.75 142.97 443.87 59.58 348.35 166.55 409.51 183.5 382.54 280.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "287.99 220.05 225.22 86.69 281.42 83.97 277.44 1.64 343.74 121.08 283.35 124 287.99 220.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "225.27 259.9 203.44 159.65 171.25 181.96 138.56 134.81 152.55 228.86 187.14 204.88 225.27 259.9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmpi);
export default __webpack_public_path__ + "static/media/fmpi.f97e279774176a475fe6034262a7a0db.svg";
export { ForwardRef as ReactComponent };